import { call, put, takeLatest, delay } from 'redux-saga/effects';

import defaultActions, { sendSuccess, sendFailed, clearForm } from '../actions';
import { putSession, postFeedback } from '../../../globals/api/requests';
import { isValidEmail } from '../../account/helpers';

export function* sendFeedback({ message }) {
  if (!message.email || !isValidEmail(message.email)) {
    yield put(sendFailed('error.missing.email'));
    return;
  }

  if (!message.message) {
    yield put(sendFailed('error.missing.message'));
    return;
  }

  try {
    const response = yield call(postFeedback, message);

    if (response.errors && response.errors.length) {
      yield put(sendFailed(response.errors[0].message));
    } else {
      yield put(sendSuccess());
      yield call(putSession, 'email', message.email);
      yield delay(1500);
      yield put(clearForm());
      yield put(defaultActions.close());
    }
  } catch (e) {
    yield put(sendFailed(e.message));
  }
}

function* mySaga() {
  yield takeLatest('FEEDBACK_SEND_REQUEST', sendFeedback);
}

export default mySaga;
